module.exports = __webpack_public_path__ + "static/media/app-store-badge.8613fd84.png";